import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '../../../contexts/AuthContext'
import { isTokenExpired } from '../../../utils/jwtUtils'

type GuestGuardProps = {
  redirectPath?: string
}

const GuestGuard = ({ redirectPath = '/dashboard' }: GuestGuardProps) => {
  const { authInfo, isAuthenticated } = useAuth()
  const accessToken = authInfo?.accessToken

  const hasValidAuthentication =
    isAuthenticated && accessToken && !isTokenExpired(accessToken)

  if (hasValidAuthentication) {
    return <Navigate to={redirectPath} replace />
  }

  return <Outlet />
}

export default GuestGuard
